import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

export const nutritionistAppointmentsAdapter = createEntityAdapter({
  selectId: appointment => appointment._id,
  sortComparer: (appointmentA, appointmentB) => {
    return new Date(appointmentA.startDate) - new Date(appointmentB.startDate);
  },
});

export const nutritionistAppointmentsSlice = createSlice({
  name: 'wnAppointments',
  initialState: {
    appointments: nutritionistAppointmentsAdapter.getInitialState(),
    activeId: null,
  },
  reducers: {
    setNutritionistAppointments: (state, action) => {
      nutritionistAppointmentsAdapter.setAll(
        state.appointments,
        action.payload,
      );
    },
    setNutritionistAppointmentActiveId: (state, action) => {
      state.activeId = action.payload;
    },
  },
});

export const {
  setNutritionistAppointments,
  setNutritionistAppointmentActiveId,
} = nutritionistAppointmentsSlice.actions;

export const WnNutritionistAppointmentsReducer =
  nutritionistAppointmentsSlice.reducer;
